import { isAgentsEmbed } from '@/lib/agents-embed';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../../messages/en.json';
import es from '../../messages/es.json';
import { defaultLocale, locales, type Locale } from './config';

function getInitialLocale(): Locale {
  if (typeof window === 'undefined') return defaultLocale;
  let stored: string | null = null;
  if (!isAgentsEmbed()) {
    try { stored = window.localStorage?.getItem('fyso-locale'); } catch { /* storage is optional */ }
  }
  if (stored && locales.includes(stored as Locale)) return stored as Locale;
  const browserLang = navigator.language.split('-')[0];
  if (locales.includes(browserLang as Locale)) return browserLang as Locale;
  return defaultLocale;
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
  },
  lng: getInitialLocale(),
  fallbackLng: defaultLocale,
  interpolation: { escapeValue: false, prefix: '{', suffix: '}' },
});

export default i18n;
